import React from 'react';
import { advancedMetrics } from './constants';
import { AdvancedMetricVisualization } from './AdvancedVisualizations';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
interface AdvancedTabProps {
  selectedAdvancedMetric: string;
  setSelectedAdvancedMetric: (id: string) => void;
}
export const AdvancedTab = ({
  selectedAdvancedMetric,
  setSelectedAdvancedMetric
}: AdvancedTabProps) => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  // Referenced by the sidebar hover ternary below but was never declared.
  const darkMode = dk.isDark;
  return <div className={`rounded-lg shadow-sm border ${dk.card}`} data-id="element-5509" data-mp="2rn2deh1sh1y">
      <div className="flex flex-col md:flex-row" data-id="element-5510" data-mp="3u00y47y5nz4c">
        {/* Sidebar */}
        <div className={`w-full md:w-64 border-r ${dk.border}`} data-id="element-5511" data-mp="2njffszwyz4az">
          <div className={`p-4 border-b ${dk.border}`} data-id="element-5512" data-mp="2nl080ivtab5o">
            <h2 className={`text-lg font-semibold ${dk.textPrimary}`} data-id="element-5513" data-mp="2ijuguphsuvy9">
              Advanced Features
            </h2>
            <p className={`text-sm mt-1 ${dk.textSecondary}`} data-id="element-5514" data-mp="ry0i7ke4hzdi">
              Powerful analytics tools for authors
            </p>
          </div>
          <div className="overflow-y-auto" style={{
          maxHeight: 'calc(100vh - 200px)'
        }} data-id="element-5515" data-mp="wtpmu25026go">
            <ul className="py-2" data-id="element-5516" data-mp="mwuszwjo8u8q">
              {advancedMetrics.map(metric => <li key={metric.id} data-id="element-5517" data-mp="967qdtasik7d">
                  <button onClick={() => setSelectedAdvancedMetric(metric.id)} className={`w-full flex items-center p-2 text-left transition-colors ${selectedAdvancedMetric === metric.id ? `${rt.bgMedium} ${rt.textPrimary}` : `${dk.textSecondary} ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}`} data-id="element-5518" data-mp="956exnpv3vp4">
                    <div className="mr-3" data-id="element-5519" data-mp="3me2h7oiqbcbt">{metric.icon}</div>
                    <div className={`font-medium truncate`} data-id="element-5520" data-mp="3qelaln09sqg4">{metric.title}</div>
                  </button>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 p-6" data-id="element-5521" data-mp="1s4njuyfdu5gc">
          {advancedMetrics.map(metric => <div key={metric.id} className={selectedAdvancedMetric === metric.id ? 'block' : 'hidden'} data-id="element-5522" data-mp="1n62kt2bv9rth">
              <div className="flex items-start mb-6" data-id="element-5523" data-mp="1i4wq4yynbuhb">
                <div className="bg-teal-100 p-3 rounded-lg mr-4" data-id="element-5524" data-mp="2ftowyyz5u4ry">
                  {metric.icon}
                </div>
                <div data-id="element-5525" data-mp="2aw6mh45hvhhu">
                  <h2 className={`text-2xl font-bold ${dk.textPrimary}`} data-id="element-5526" data-mp="2atkckxv4spwg">
                    {metric.title}
                  </h2>
                  <p className={`mt-1 ${dk.textSecondary}`} data-id="element-5527" data-mp="21v8ob2hqm476">
                    {metric.description}
                  </p>
                </div>
              </div>
              <div className="space-y-6" data-id="element-5528" data-mp="ufarqdq3ljad">
                <div className={`p-5 rounded-lg ${dk.surfaceMuted}`} data-id="element-5529" data-mp="qfa9sj3sipyk">
                  <h3 className={`text-lg font-medium mb-3 ${dk.textPrimary}`} data-id="element-5530" data-mp="3235fuifp4c5k">
                    How It Works
                  </h3>
                  <p className={dk.textSecondary} data-id="element-5531" data-mp="363z6hjkiw525">{metric.details}</p>
                </div>
                <div className={`border rounded-lg p-6 ${dk.border}`} data-id="element-5532" data-mp="3b3bsy37hfa47">
                  <div className="flex items-center justify-between mb-4" data-id="element-5533" data-mp="3fujygo5oybc3">
                    <h3 className={`text-lg font-medium ${dk.textPrimary}`} data-id="element-5534" data-mp="3fvv64z29c38h">
                      Sample Data Visualization
                    </h3>
                    <span className="text-xs bg-amber-100 text-amber-800 px-2 py-1 rounded-full" data-id="element-5535" data-mp="3pryfopzfv45g">
                      Preview
                    </span>
                  </div>
                  <AdvancedMetricVisualization metricId={metric.id} data-id="element-5536" data-mp="2o1ud52swn16" />
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};